import { createFileRoute } from '@tanstack/react-router';

import { ViewRemediationDetail } from '@/features/view-remediation/ViewRemediationDetail';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';

export const Route = createFileRoute('/_protected/t/$tenantId/view-remediation/$viewId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { viewId } = Route.useParams();
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <ViewRemediationDetail viewId={viewId} />
    </ErrorBoundary>
  );
}
